import { render, staticRenderFns } from "./flag-icons.vue?vue&type=template&id=37dfa6f5"
import script from "./flag-icons.vue?vue&type=script&lang=js"
export * from "./flag-icons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports